module.exports = __webpack_public_path__ + "static/media/explosion-yellow.0e047df2.png";